import { render, staticRenderFns } from "./FieldType8Configure.vue?vue&type=template&id=1753725e&scoped=true"
import script from "./FieldType8Configure.vue?vue&type=script&lang=js"
export * from "./FieldType8Configure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1753725e",
  null
  
)

export default component.exports